import { SnapManager } from './SnapManager';

/**
 * Factory function to create a SnapManager instance
 * @param {fabric.Canvas} canvas - The fabric canvas
 * @param {Object} options - Configuration options
 * @returns {SnapManager} New SnapManager instance
 */
export const createSnapManager = (canvas, options = {}) => {
  return new SnapManager(canvas, options);
};
